import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo'
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';
import TeacherCombo from '../combos/TeacherCombo';
import FaDate from '../shared/FaDate';
import EduMonthCombo from '../combos/EduMonthCombo';


export default function EmployeeAbsentHoursReport(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showList, setShowList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [month, setMonth] = useState(null);

  useEffect(() => {
    setLoading(false);



  }, []);

  const btnShowList_Click = function(){
    if((month == null)||(month == {})||(month == "")||(month <= 0)){
        setErorVisible(true);
        setErrorMessage("ماه تحصیلی را مشخص نمائید");
        return;
    }

    setLoading(true);
    var params = { login: util.getTrustedUser(), monthNo: month };
    var url = config.Server + `/school/employee/absent/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setItems(response);
          setShowList(true);

          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setLoading(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setLoading(false);
      });

    
  }

  return (
    (redirectUrl != "")
        ?
        <Navigate to={redirectUrl} replace={false}  />
    :
    <>
      <ShowVideo videoId="school_create_classes" top={65} md={6} />
      <div className="card" style={{marginBottom:"20px", padding:"10px"}}>
          <Row>
            <Col md={4}>
              <EduMonthCombo value={month} onChange={(value)=>{setMonth(value); setShowList(false)}} />
            </Col>
            <Col md={3} style={{paddingTop:"30px", direction:"ltr", textAlign:"right"}}>
              <Button label="مشاهده لیست" icon="pi pi-search" onClick={() => btnShowList_Click()} severity="success" iconPos="right" loading={loading} />
            </Col>
            <Col md={3} style={{paddingTop:"30px", direction:"ltr", textAlign:"right"}}>
              <Button label="برگشت" icon="pi pi-left" onClick={() => setRedirectUrl("/school/employee/absent-hours")} severity="info" iconPos="right" />
            </Col>
          </Row>
      </div>
      {
        showList?
        <>
        <div className="card">
              <div className="page-caption">لیست ساعت های غیبت</div>
        
              <DataTable value={items} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows 
                dataKey="id"  onSelectionChange={(e) => {  }}>
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="firstname" body={(row) => row.employee.firstname} header={"نام"} sortable className="list-cell-text-align"></Column>
                <Column field="lastname" body={(row) => row.employee.lastname} header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                <Column field="hours" header={"ساعت"} sortable className="list-cell-text-align"></Column>
                <Column field="days" header={"روز"} sortable className="list-cell-text-align"></Column>
              </DataTable>
        </div>
        </>
        :
        <></>
      }
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />

    </>
  );
}
